setUserAcquisitions